import {useQuery} from "@tanstack/react-query";
import {userRoleList} from "../utils/constants";
import {useMe} from "./useGetUser";
import {invoiceApi} from "../services/invoiceService";

export const useInvoices = ({page, size}) => {
  const {data: user, isLoading: isLoadingUser} = useMe();
  const filter =
    user?.selectedRole === userRoleList.CLIENT
      ? {clientId: user?.Client?.id}
      : {technicianId: user?.Technician?.id};

  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["invoices", user?.id, user?.selectedRole, page, size],
    queryFn: () => invoiceApi.getAll({page, size, filter: {...filter}}),
    enabled: !!user && !isLoadingUser,
    select: (data) => data,
  });

  return {
    data: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
